import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { register, load, getInstances } from '@shopify/theme-sections';
Avatar.theme = Avatar.theme || {};
Avatar.theme.sections = Avatar.theme.sections || {};
var sectionName = 'footer';

Avatar.theme.sections.SectionName = function SectionName() {
  var selectors = {
    disclosureLocale: '[data-disclosure-locale]',
    disclosureCurrency: '[data-disclosure-currency]'
  };
  register(sectionName, {
    onLoad: function onLoad() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var container;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                container = _this.container;
                _this.localeDisclosure = container.querySelector(selectors.disclosureLocale);
                _this.currencyDisclosure = container.querySelector(selectors.disclosureCurrency);

                if (_this.localeDisclosure) {
                  _this.localeDisclosure = new Avatar.theme.Disclosure(_this.localeDisclosure);
                }

                if (_this.currencyDisclosure) {
                  _this.currencyDisclosure = new Avatar.theme.Disclosure(_this.currencyDisclosure);
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onUnload: function onUnload() {
      if (this.cache.localeDisclosure) {
        this.localeDisclosure.destroy();
      }

      if (this.cache.currencyDisclosure) {
        this.currencyDisclosure.destroy();
      }
    }
  });
  load(sectionName);
  var instance = getInstances(sectionName);
  return instance[0];
}();